/* @flow */
import CopyToClipboardField from './CopyToClipboardField';

export default CopyToClipboardField;
